// PaymentForm.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";

const PaymentForm = () => {
  const [formData, setFormData] = useState({
    access_key: "63c8c15c983837f4bd3936fb19f93f51",
    profile_id: "303FF8D2-7E53-4A8A-952E-8314422CDC55",
    transaction_uuid: "",
    signed_field_names:
      "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency",
    unsigned_field_names: "",
    signed_date_time: "",
    locale: "en-us",
    transaction_type: "authorization",
    reference_number: "",
    amount: "",
    currency: "OMR",
  });

  // Generate UUID and set the current time on component mount
  useEffect(() => {
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19) + "Z";

    setFormData((prev) => ({
      ...prev,
      transaction_uuid: uuid,
      signed_date_time: utcDateTime,
    }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Update the signed date time before submission
    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19) + "Z";

    const updatedFormData = {
      ...formData,
      signed_date_time: utcDateTime,
    };

    try {
      // Send the form data to the server for signing
      const response = await axios.post(
        "http://localhost:4005/graphql/sign_request",
        updatedFormData
      );

      // Create a form and submit it to Cybersource
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://testsecureacceptance.cybersource.com/pay";

      // Add all fields from the response
      for (const key in response.data) {
        if (response.data.hasOwnProperty(key)) {
          const hiddenField = document.createElement("input");
          hiddenField.type = "hidden";
          hiddenField.name = key;
          hiddenField.value = response.data[key];
          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Error signing request:", error);
    }
  };

  return (
    <div>
      <h1>Payment Form</h1>
      <form onSubmit={handleSubmit}>
        <fieldset>
          <legend>Payment Details</legend>
          <div>
            <label>Reference Number</label>
            <input
              type="text"
              name="reference_number"
              value={formData.reference_number}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label>Amount</label>
            <input
              type="text"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label>Currency</label>
            <select
              name="currency"
              value={formData.currency}
              onChange={handleChange}
            >
              <option value="OMR">OMR</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
            </select>
          </div>
        </fieldset>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default PaymentForm;

// import React, { useState } from "react";
// import axios from "axios";

// function PaymentForm() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     amount: "100.00",
//   });
//   const [message, setMessage] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         "http://localhost:4005/graphql/create-payment",
//         formData
//       );

//       // Create hidden form for CyberSource redirect
//       const form = document.createElement("form");
//       form.method = "POST";
//       form.action = response.data.url;

//       Object.entries(response.data.fields).forEach(([key, value]) => {
//         const input = document.createElement("input");
//         input.type = "hidden";
//         input.name = key;
//         input.value = value;
//         form.appendChild(input);
//       });

//       document.body.appendChild(form);
//       form.submit();
//     } catch (error) {
//       setMessage("Payment initialization failed. Please try again.");
//       console.error("Error:", error);
//     }
//   };

//   return (
//     <div
//       className="App"
//       style={{ maxWidth: "500px", margin: "0 auto", padding: "20px" }}
//     >
//       <h1>Payment Form</h1>
//       <form
//         onSubmit={handleSubmit}
//         style={{ display: "flex", flexDirection: "column", gap: "15px" }}
//       >
//         <div>
//           <label>Full Name: </label>
//           <input
//             type="text"
//             value={formData.name}
//             onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//             required
//             style={{ width: "100%", padding: "8px" }}
//           />
//         </div>

//         <div>
//           <label>Email: </label>
//           <input
//             type="email"
//             value={formData.email}
//             onChange={(e) =>
//               setFormData({ ...formData, email: e.target.value })
//             }
//             required
//             style={{ width: "100%", padding: "8px" }}
//           />
//         </div>

//         <div>
//           <label>Amount (USD): </label>
//           <input
//             type="number"
//             step="0.01"
//             min="1"
//             value={formData.amount}
//             onChange={(e) =>
//               setFormData({ ...formData, amount: e.target.value })
//             }
//             required
//             style={{ width: "100%", padding: "8px" }}
//           />
//         </div>

//         <button
//           type="submit"
//           style={{
//             padding: "10px 20px",
//             backgroundColor: "#007bff",
//             color: "white",
//             border: "none",
//             borderRadius: "4px",
//             cursor: "pointer",
//           }}
//         >
//           Proceed to Payment
//         </button>
//       </form>

//       {message && <p style={{ color: "red", marginTop: "15px" }}>{message}</p>}
//     </div>
//   );
// }

// export default PaymentForm;
